import React, { createContext, useContext, useState } from "react";
import axiosInstance, { handleApiError } from "../services/axiosService";
import { updateActivityChecksum } from "../utils/configChecksum/setterFunctions/activityConfig";
import { useFormContext } from "./FormContext";
import { useTreeContext } from "./TreeDataContext";
import { updateStateChecksum } from "../utils/configChecksum/setterFunctions/stateConfig";
import { getTreeDataForStateMachine } from "../utils/treeData/treeDataUtils";

const StatemachineContextApi = createContext();

const useStatemachineContext = () => useContext(StatemachineContextApi);

const StatemachineContext = ({ children }) => {
  const { setStateMachineExplorerData } = useTreeContext();

  const [selectedStateMachine, setSelectedStateMachine] = useState({
    id: "",
    name: "",
    stateid: "",
    statename: ""
  });
  // for state
  const [textareaValue, setTextareaValue] = useState("");
  const [rememberData, setRememberData] = useState({
    allow_state_targets: [],
    deny_states_targets: [],
    allow_state_sources: [],
    deny_states_sources: [],
    allow_activities: [],
    deny_activities: [],
    source_activity: [],
    allow_gateway_targets: []
  });

  // for activity
  const [activityData, setActivityData] = useState({
    activity_owner_assignment: {},
    state_change_logic: [],
    jobs_trigger: [],
    pre_activity_job: [],
    pre_submission: [],
    jobs_trigger_formula: "",
    type: "",
    description: "",
    activity_response: {},
    sort_by: {
      key: "",
      order: ""
    },
    allowed_count: 0
  });

  const [allProCode, setAllProCode] = useState([]);
  const [smUniqueFields, setSmUniqueFields] = useState([]);

  const [selectedStateMachineBlueprint, setSelectedStateMachineBlueprint] = useState(null);
  const { renderFieldsArray, renderFieldsData } = useFormContext();

  const fetchAllStateMachine = async () => {
    const response = await axiosInstance.get(`/state-machines`);
    const treeData = getTreeDataForStateMachine("all", response.data);
    setStateMachineExplorerData(treeData);
    return response;
  };
  const getStatemachineConfig = () => {
    const type = selectedStateMachine.statename;
    if (type === "states") {
      return {
        remember: rememberData,
        description: textareaValue
      };
    }
    if (type === "activities") {
      return activityData;
    }
    if (type === "statemachine") {
      const arrayCopy = [...renderFieldsArray];
      arrayCopy.sort((a, b) => a.y - b.y);

      //handle all outer field in form
      const newArray = arrayCopy.map((field) => {
        return renderFieldsData.current[field.i];
      });
      if (!selectedStateMachineBlueprint.global_data_form) {
        selectedStateMachineBlueprint.global_data_form = {
          fields: []
        };
      }
      selectedStateMachineBlueprint.global_data_form.fields = newArray;
      selectedStateMachineBlueprint.pro_code = allProCode;
      selectedStateMachineBlueprint.unique_fields = smUniqueFields;
      return selectedStateMachineBlueprint;
    }
  };

  const handleSaveStatemachine = async (options) => {
    try {
      let config = getStatemachineConfig();
      let url;
      if (selectedStateMachine.statename === "statemachine") {
        config = {
          config,
          checksum: options.options.checksum
        };
        url = `/state-machine/${selectedStateMachine.id}/canvas`;
      } else {
        url = `/state-machine/${selectedStateMachine.stateid}/${selectedStateMachine.statename}/${selectedStateMachine.id}`;
      }
      const { message, data } = await axiosInstance.put(url, config);
      if (selectedStateMachine.statename === "activities") {
        updateActivityChecksum(config);
      }
      if (selectedStateMachine.statename === "states") {
        updateStateChecksum(config);
      }
      return { data: data, message };
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  };

  const payloadStateList = [textareaValue, rememberData, activityData];

  return (
    <StatemachineContextApi.Provider
      value={{
        selectedStateMachine,
        setSelectedStateMachine,
        rememberData,
        setRememberData,
        activityData,
        setActivityData,
        selectedStateMachineBlueprint,
        setSelectedStateMachineBlueprint,
        handleSaveStatemachine,
        fetchAllStateMachine,
        getStatemachineConfig,
        textareaValue,
        setTextareaValue,
        allProCode,
        setAllProCode,
        smUniqueFields,
        setSmUniqueFields,
        payloadStateList
      }}
    >
      {children}
    </StatemachineContextApi.Provider>
  );
};

export default StatemachineContext;
export { useStatemachineContext };
